import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  header: {
    fontSize: 16,
  },
  content: {
    marginTop: 16,
    fontSize: 14,
    color: '#515B6A',
  },
  avatar: {
    marginTop: 10,
    marginRight: 15,
    width: 34,
    height: 34,
  },
  text: {
    width: '100%',
    paddingTop: 17,
  },
  timestamp: {
    fontSize: '12px',
    color: '#515B6A',
    marginLeft: '7px',
    whiteSpace: 'nowrap',
  },
  accent: {
    fontSize: 16,
    color: '#263245',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  comment: {
    marginBottom: 40,
  },
  message: {
    maxHeight: '25vh',
    overflow: 'auto',
  },
  lineBreak: {
    border: 'none',
    color: '#DCDEE5',
    backgroundColor: '#DCDEE5',
    height: 1,
  },
  alertMessage: {
    fontWeight: 500,
    color: '#F8221A',
  },
  italicAccent: {
    fontFamily: 'Roboto',
    fontStyle: 'italic',
  },
}));

export default useStyles;
